import { useContext } from 'react';
import { HttpContext } from '@wix/yoshi-serverless-react';
import { assertEnabledApi } from '../../util';
import { WidgetEnvironmentContext } from '../EnvironmentProvider';
export var useHttpClient = function () {
    if (process.env.NODE_ENV !== 'production') {
        // Use WidgetEnvironmentContext to determine whether we're under `Widget` or not.
        // This relies on the fact that `WidgetEnvironmentContext.Provider` is missing and that the default value is `null`.
        // We either always get into this if or not, so it should be safe for react-hooks.
        // eslint-disable-next-line react-hooks/rules-of-hooks
        var widgetEnvironment = useContext(WidgetEnvironmentContext);
        if (widgetEnvironment) {
            throw new Error("`useHttpClient()` can't be used within a `Widget` component. Please pass a function from the controller to use HttpClient.");
        }
    }
    var client = useContext(HttpContext).client;
    assertEnabledApi(client, 'HttpClient');
    return client;
};
//# sourceMappingURL=useHttpClient.js.map